module.exports = __webpack_public_path__ + "static/img/052 1.89b30060.jpg";